import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

import { timeout } from '../../lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'VideoPlayerLazy',
        path: () => path.join(__dirname, './VideoPlayer'),
        resolve: () => require.resolveWeak('./VideoPlayer'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "VideoPlayerLazy" */ './VideoPlayer')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
